import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <h1 mat-dialog-title>{{ data.title || 'Confirmação' }}</h1>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
      <p>{{ data.message }}</p>
    </div>
    <mat-dialog-actions align="end">
      <button mat-button class="cancel-button" (click)="onCancel()">Cancelar</button>
      <button mat-raised-button class="confirm-button" (click)="onConfirm()">Confirmar</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .cancel-button {
      background-color: transparent;
      color: inherit;
      transition: background-color 0.3s ease;
    }
    .cancel-button:hover {
      background-color: #e0e0e0;
    }
    .confirm-button {
        background-color:rgb(169, 1, 1);
        color: white;
      transition: background-color 0.3s ease;
    }
    .confirm-button:hover {
      background-color:rgb(199, 0, 0);
    }
  `]
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }
  
  onCancel(): void {
    this.dialogRef.close(false);
  }
}
